const VIEW_TYPES = {
  CHAT: 'chat',
  LIST: 'list'
};

export { VIEW_TYPES };
